export const CHANNEL_TALK_URL = 'https://bznavcare1.channel.io';
export const FALLBACK_RESOURCE_CENTER_URL = 'https://prd.cdn.bznav.com';
